export default __webpack_public_path__ + "static/media/mu.592b06ed.jpg";